<template>
  <div>
    <a-card :bordered="false" class="header-solid" style="max-width:980px">
      <template #title>
        <div style="display:flex;align-items:center;justify-content:space-between">
          <div>
            <h5 class="font-semibold m-0">套餐管理</h5>
            <p class="text-muted m-0" style="font-size:13px">配置客户端订阅套餐(价格以 USDT 计),客户在线支付后自动续期。</p>
          </div>
          <a-button type="primary" icon="plus" @click="openEdit(null)">新增套餐</a-button>
        </div>
      </template>

      <a-table
        :columns="columns"
        :data-source="plans"
        :loading="loading"
        row-key="id"
        :pagination="false"
        size="middle">
        <template #name="name, row">
          <span style="font-weight:600">{{ name }}</span>
          <a-tag v-if="row.badge" color="orange" style="margin-left:6px">{{ row.badge }}</a-tag>
        </template>
        <template #price="price">
          <span style="color:#0b8235;font-weight:600">{{ price }} u</span>
        </template>
        <template #days="days">{{ days }} 天</template>
        <template #domains="domains">{{ domains }} 个</template>
        <template #enabled="enabled, row">
          <a-switch :checked="!!enabled" @change="(v) => toggleEnabled(row, v)" />
        </template>
        <template #action="text, row">
          <a @click="openEdit(row)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除该套餐?" ok-text="删除" cancel-text="取消" @confirm="doDelete(row)">
            <a style="color:#cf1322">删除</a>
          </a-popconfirm>
        </template>
      </a-table>
      <a-empty v-if="!loading && plans.length === 0" description="还没有套餐,点右上角「新增套餐」" style="margin:24px 0" />
    </a-card>

    <a-modal :visible="editVisible" :title="form.id ? '编辑套餐' : '新增套餐'"
      :confirm-loading="saving" ok-text="保存" cancel-text="取消"
      @ok="doSave" @cancel="editVisible = false" :width="560">
      <a-form-model layout="vertical">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="套餐名称" required>
              <a-input v-model="form.name" placeholder="如:月付套餐" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="角标(可空)">
              <a-input v-model="form.badge" placeholder="如:热门 / 推荐 / 特惠" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="8">
            <a-form-model-item label="价格(USDT)" required>
              <a-input-number v-model="form.price" :min="0" :step="1" style="width:100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="时长(天)" required>
              <a-input-number v-model="form.days" :min="1" :step="1" style="width:100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="托管位(个)">
              <a-input-number v-model="form.domains" :min="0" :step="1" style="width:100%" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item label="功能点(每行一条,展示在套餐卡片上)">
          <a-textarea v-model="form.featuresText" :rows="5"
            placeholder="赠送 1 个独立域名&#10;自动接入 Cloudflare&#10;多平台像素回传&#10;到期 Telegram 提醒" />
        </a-form-model-item>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="排序(小的在前)">
              <a-input-number v-model="form.sort" :min="0" :step="1" style="width:100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="是否启用">
              <a-switch v-model="form.enabled" /> <span class="text-muted" style="margin-left:8px">{{ form.enabled ? '客户端可见' : '客户端隐藏' }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { planListAll, planSave, planDelete } from '../../api/index';

const blankForm = () => ({
  id: '', name: '', price: 30, days: 30, domains: 1,
  featuresText: '', badge: '', sort: 0, enabled: true,
});

export default {
  data() {
    return {
      loading: false,
      saving: false,
      plans: [],
      editVisible: false,
      form: blankForm(),
      columns: [
        { title: '名称', dataIndex: 'name', scopedSlots: { customRender: 'name' } },
        { title: '价格', dataIndex: 'price', width: 110, scopedSlots: { customRender: 'price' } },
        { title: '时长', dataIndex: 'days', width: 90, scopedSlots: { customRender: 'days' } },
        { title: '托管位', dataIndex: 'domains', width: 90, scopedSlots: { customRender: 'domains' } },
        { title: '排序', dataIndex: 'sort', width: 70 },
        { title: '状态', dataIndex: 'enabled', width: 90, scopedSlots: { customRender: 'enabled' } },
        { title: '操作', width: 130, scopedSlots: { customRender: 'action' } },
      ],
    };
  },
  created() { this.load(); },
  methods: {
    load() {
      this.loading = true;
      planListAll().then((res) => {
        this.plans = (res && res.data) ? res.data : [];
      }).catch(() => this.$message.error('加载套餐失败')).finally(() => this.loading = false);
    },
    openEdit(row) {
      if (row) {
        this.form = {
          id: row.id, name: row.name, price: row.price, days: row.days,
          domains: row.domains || 0, badge: row.badge || '', sort: row.sort || 0,
          enabled: row.enabled !== false,
          featuresText: (row.features || []).join('\n'),
        };
      } else {
        this.form = blankForm();
      }
      this.editVisible = true;
    },
    doSave() {
      if (!this.form.name || !this.form.name.trim()) { this.$message.warning('请填写套餐名称'); return; }
      if (!(this.form.price > 0) || !(this.form.days > 0)) { this.$message.warning('价格和时长必须大于 0'); return; }
      const plan = {
        id: this.form.id || '',
        name: this.form.name.trim(),
        price: this.form.price,
        days: this.form.days,
        domains: this.form.domains || 0,
        badge: (this.form.badge || '').trim(),
        sort: this.form.sort || 0,
        enabled: this.form.enabled,
        features: (this.form.featuresText || '').split('\n').map(s => s.trim()).filter(Boolean),
      };
      this.saving = true;
      planSave(plan).then((res) => {
        if (res && res.status === 200) { this.$message.success('已保存'); this.editVisible = false; this.load(); }
        else this.$message.error((res && res.message) ? res.message : '保存失败');
      }).catch((e) => this.$message.error((e && e.message) ? e.message : '保存失败')).finally(() => this.saving = false);
    },
    toggleEnabled(row, v) {
      const plan = {
        id: row.id, name: row.name, price: row.price, days: row.days,
        domains: row.domains || 0, badge: row.badge || '', sort: row.sort || 0,
        enabled: v, features: row.features || [],
      };
      planSave(plan).then((res) => {
        if (res && res.status === 200) { this.$message.success(v ? '已上架' : '已下架'); this.load(); }
        else { this.$message.error('操作失败'); this.load(); }
      }).catch(() => { this.$message.error('操作失败'); this.load(); });
    },
    doDelete(row) {
      planDelete(row.id).then((res) => {
        if (res && res.status === 200) { this.$message.success('已删除'); this.load(); }
        else this.$message.error('删除失败');
      }).catch(() => this.$message.error('删除失败'));
    },
  },
};
</script>
